import AvatarIcon from "@components/UI/AvatarIcon.jsx";
import Button from "@components/UI/Button";
import sendLogo from "@img/send.svg";
import attachmentLogo from "@img/attachment.svg";

import { useState } from "react";
import { useAuth } from "@/utils/auth-context.tsx";
import InvestorModal from "@components/InvestorModal.jsx";

const Investor = () => {
  const investors = [
    {
      name: "Алексей",
      amount: 2000,
      platforms: ["Shopify"],
    },
    {
      name: "Жумаш",
      amount: 1000,
      platforms: ["Amazon"],
    },
    {
      name: "Орлан",
      amount: 5000,
      platforms: ["Amazon", "TikTok"],
    
    },
    {
      name: "Сергей",
      amount: 20000,
      platforms: ["Kaspi", "WB"],
    },
    {
      name: "Артур",
      amount: 15000,
      platforms: ["eBay", "TikTok", "Amazon"],
    },
    {
      name: "Андрей",
      amount: 7000,
      platforms: ["Shopify"],
    },
  ];

  const [isModalOpen, setModalOpen] = useState(false);
  const { isVerified } = useAuth();

  return (
    <div
      className="layout layout--dark chat chat--dark  chat-invest"
      onClick={() => setModalOpen(true)}
    >
      {isModalOpen &&
        (isVerified ? (
          <InvestorModal closeModal={() => setModalOpen(false)} />
        ) : (
          <InvestorModal
            text={`Доступ временно закрыт`}
            closeModal={() => setModalOpen(false)}
          />
        ))}

      <div className={"chat-invest-users"}>
        {investors.map((investor, index) => (
          <div key={index} className={"chat-invest-users-item"}>
            {investor.img ? (
              <AvatarIcon image={investor.img}></AvatarIcon>
            ) : (
              <AvatarIcon item={investor.name}></AvatarIcon>
            )}

            <div className={"chat-invest-users-item-text"}>
              <p>{investor.name}</p>
              <p className={"chat-invest-users-item__amount"}>
                Готов инвестировать {investor.amount}${" "}
              </p>
              <div className={"chat-invest-users-item-platforms"}>
                {investor.platforms.map((platform, index) => (
                  <div
                    key={index}
                    className={"chat-invest-users-item-platforms__item"}
                  >
                    {platform}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="chat-main chat-main--dark ">
        <div className="chat-header">
          <h3> Инвесторы - Чат </h3>
        </div>
        <div className="chat-body chat-body--dark chat-body--invest">
          <p
            className={
              "chat-header-status__subtitle chat-header-status__subtitle--invest "
            }
          >
            Готовы начать? Выберите инвестора и начните чат!{" "}
          </p>
          <div className="chat-input chat-input--dark">
            <input disabled type={"text"} className={"chat-input__text"} />
            <Button
              color={"blue"}
              image={attachmentLogo}
              onClick={() => null}
            ></Button>
            <Button
              image={sendLogo}
              color={"black"}
              onClick={() => null}
            ></Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Investor;
